/**
 * @author Sai Prasad
 * @class OtherDetails
 */
import React from 'react';
import Row from "../Row";
import Col from "../Col";
import Icon from "../Icon";

const OtherDetails = ({
    keyValuePairs,
    onInputChange,
    onAddPair,
    onRemovePair
}) => {
    return (
        <div style={{ marginTop: 10, marginBottom: 10 }}>
            <label className="file__label">Other Details :</label>
            <Row>
                {keyValuePairs.map((item, i) => {
                    const validation = item.key?.trim() && item.value?.trim();
                    return (
                        <Col xs="12" md="4">
                            <Row style={{ marginBottom: 20 }}>
                                <Col md="5" xs="12" style={{ marginRight: 10 }}>
                                    <input
                                        className="input__control"
                                        style={{fontWeight: 'bold', width:'100%'}}
                                        type='text'
                                        value={item.key}
                                        onChange={(e) => onInputChange(e.target.value, item, 'key')}
                                        placeholder='Key'
                                    />
                                </Col>
                                <Col md="5" xs="12">
                                    <input
                                        className="input__control"
                                        style={{width:'100%'}}
                                        type='text'
                                        value={item.value}
                                        onChange={(e) => onInputChange(e.target.value, item, 'value')}
                                        placeholder='Value'
                                    />
                                </Col>
                                <Col md="1" xs="2">
                                    <div className='iconCircle' onClick={() => (keyValuePairs.length - 1 === i) ? validation && onAddPair() : onRemovePair(item)}>
                                        <Icon
                                            glyph={(keyValuePairs.length - 1 === i) ? validation && "plus-circle" : "minus-circle"}
                                            weight="light"
                                            size="small"
                                            
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    )
                })}
            </Row>
        </div>
    )
}

export default OtherDetails;